module.exports = __webpack_public_path__ + "static/media/sidebar_background.50ba7e4d.jpg";